exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".btn .fa[data-v-e2e2944a]:not(.fa-play) {\n  margin-right: 0;\n}\n", ""]);

